import Logo from '../Logo';
import { Link } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";

function MenuLateral(props){
    
    const admin = props.admin;

    const [MenuFiliado, setMenuFiliado] = useState('');
    const [MenuUsuario, setMenuUsuario] = useState('');
    const [MenuAdminEmplacar, setMenuAdminEmplacar] = useState('');
    const [RelEmplacamento, setRelEmplacamento] = useState('');    
    const [RelIntencaoVenda, setRelIntencaoVenda] = useState('');        
    const [MenuVeiculo, setMenuVeiculo] = useState('');
    const [MenuEmplacar, setMenuEmplacar] = useState('');
    const [MenuIVenda, setMenuIVenda] = useState('');
    const [RelFiliadoEmplacamento, setRelFiliadoEmplacamento] = useState('');    
    const [RelFiliadoIntencaoVenda, setRelFiliadoIntencaoVenda] = useState('');        
    const [isCollapsed, setIsCollapsed] = useState(false);

    const AtivarMenu = useCallback(() => {
        setMenuFiliado('');
        setMenuUsuario('');
        setMenuAdminEmplacar('');
        setRelEmplacamento('');
        setMenuVeiculo('');
        setMenuEmplacar('');
        setMenuIVenda('');
        setRelFiliadoEmplacamento('');
        setRelFiliadoIntencaoVenda('');

        if(props.menu === "filiado"){
            setMenuFiliado("active");
        }

        if(props.menu === "usuario"){
            setMenuUsuario("active");
        }
        
        if(props.menu === "adminEmplacar"){
            setMenuAdminEmplacar("active");
        }

        if(props.menu === "relEmplacamento"){
            setRelEmplacamento("active");
        }                

        if(props.menu === "relIntencaoVenda"){
            setRelIntencaoVenda("active");
        }                        

        if(props.menu === "veiculo"){
            setMenuVeiculo("active");
        }

        if(props.menu === "emplacar"){
            setMenuEmplacar("active");
        }

        if(props.menu === "ivenda"){
            setMenuIVenda("active");
        }

        if(props.menu === "relFiliadoEmplacamento"){
            setRelFiliadoEmplacamento("active");
        }                

        if(props.menu === "relFiliadoIntencaoVenda"){
            setRelFiliadoIntencaoVenda("active");
        }                        
    }, [props.menu]);

    useEffect(() => {
        AtivarMenu();
        const savedState = localStorage.getItem('sidebarCollapsed');
        const collapsed = savedState === null ? false : savedState === 'true';
        if (savedState === null) {
            localStorage.setItem('sidebarCollapsed', 'false');
        }
        setIsCollapsed(collapsed);
        const width = collapsed ? 'var(--sidebar-collapsed-width)' : 'var(--sidebar-min-width)';
        document.documentElement.style.setProperty('--sidebar-current-width', width);
    }, [AtivarMenu]);

    const sidebarWidth = 'var(--sidebar-current-width)';
    const sidebarClass = `sidebar-column sidebar mobile-hide tablet-hide ${isCollapsed ? 'sidebar--collapsed' : ''}`;

    return (
        <section>
            <div class={sidebarClass} style={{ width: sidebarWidth }}>
                <Link to={'/filiado'} >
                    <Logo />
                </Link>               
                <button
                    type="button"
                    class="sidebar-toggle"
                    aria-label={isCollapsed ? 'Expandir menu lateral' : 'Recolher menu lateral'}
                    aria-expanded={!isCollapsed}
                    onClick={() => setIsCollapsed(prev => {
                        const next = !prev;
                        const width = next ? 'var(--sidebar-collapsed-width)' : 'var(--sidebar-min-width)';
                        document.documentElement.style.setProperty('--sidebar-current-width', width);
                        localStorage.setItem('sidebarCollapsed', String(next));
                        return next;
                    })}
                >
                    <span class="material-symbols-outlined">{isCollapsed ? 'chevron_right' : 'chevron_left'}</span>
                </button>
                { admin &&
                    <ul class="gap-3">
                        <li id={MenuFiliado}>
                            <Link to={'/admin/filiado'} >
                                <span class="material-symbols-outlined">business</span>
                                <span class="menu-text">Filiados</span>
                            </Link>
                        </li>
                        <li id={MenuUsuario}>
                            <Link to={'/admin/usuario'} >
                                <span class="material-symbols-outlined">group</span>
                                <span class="menu-text">Usuários</span>
                            </Link>
                        </li>
                        <li id={MenuAdminEmplacar}>
                            <Link to={'/admin/emplacar'} >
                                <span class="material-symbols-outlined">settings</span>
                                <span class="menu-text">Adm. Emplacar</span>
                            </Link>
                        </li>
                        <li id={RelEmplacamento}>
                            <Link to={'/admin/relatorio/emplacamento'} >
                                <span class="material-symbols-outlined">analytics</span>
                                <span class="menu-text">Rel. Emplacamento</span>
                            </Link>
                        </li>
                        <li id={RelIntencaoVenda}>
                            <Link to={'/admin/relatorio/intencaovenda'} >
                                <span class="material-symbols-outlined">receipt_long</span>
                                <span class="menu-text">Rel. Intenção de Venda</span>
                            </Link>
                        </li>
                    </ul>                
                }
                { !admin &&
                    <ul class="gap-3">
                        <li id={MenuEmplacar}>
                            <Link to={'/filiado/emplacar'} >
                                <span class="material-symbols-outlined">car_rental</span>
                                <span class="menu-text">Emplacar</span>
                            </Link>
                        </li>
                        <li id={MenuVeiculo}>
                            <Link to={'/filiado/veiculo'} >
                                <span class="material-symbols-outlined">garage</span>
                                <span class="menu-text">Veículos</span>
                            </Link>
                        </li>
                        <li id={MenuIVenda}>
                            <Link to={'/filiado/ivenda'} >
                                <span class="material-symbols-outlined">assignment</span>
                                <span class="menu-text">Intenção de Venda</span>
                            </Link>
                        </li>
                        <li id={RelFiliadoEmplacamento}>
                            <Link to={'/filiado/relatorio/emplacamento'} >
                                <span class="material-symbols-outlined">analytics</span>
                                <span class="menu-text">Rel. Emplacamento</span>
                            </Link>
                        </li>
                        <li id={RelFiliadoIntencaoVenda}>
                            <Link to={'/filiado/relatorio/intencaovenda'} >
                                <span class="material-symbols-outlined">receipt_long</span>
                                <span class="menu-text">Rel. Intenção de Venda</span>
                            </Link>
                        </li>

                    </ul>                
                }

            </div>       

            <nav class="navbar navbar-expand-lg py-4 py-lg-0 shadow desktop-hide">
                <div class="container">
                    <Logo />
                    <button class="navbar-toggler border-0 ms-auto" type="button" data-bs-toggle="offcanvas" data-bs-target="#top-navbar-user" aria-controls="top-navbar-user">
                        <span class="material-symbols-outlined">account_circle</span>
                    </button>
                    <div class="offcanvas offcanvas-end" tabindex="-1" id="top-navbar-user" aria-labelledby="top-navbarLabel">
                        <button class="navbar-toggler border-0" type="button" data-bs-toggle="offcanvas" data-bs-target="#top-navbar-user" aria-controls="top-navbar-user">
                            <div class="d-flex justify-content-between p-3">
                                <Logo />
                                <span class="material-symbols-outlined">close</span>
                            </div>
                        </button>
                        <ul class="navbar-nav ms-lg-auto p-4 p-lg-0">
                            <li class="nav-item px-3 px-lg-0 py-1 py-lg-4">
                                <button type="button" class="nav-link">
                                    <span class="material-symbols-outlined">manage_accounts</span>Editar Perfil
                                </button>
                            </li>
                            <li class="nav-item px-3 px-lg-0 py-1 py-lg-4">
                                <button type="button" class="nav-link">
                                    <span class="material-symbols-outlined">logout</span>Logout
                                </button>
                            </li>
                        </ul>
                    </div>
                    <button class="navbar-toggler border-0" type="button" data-bs-toggle="offcanvas" data-bs-target="#top-navbar" aria-controls="top-navbar">
                        <span class="material-symbols-outlined">menu</span>
                    </button>
                    <div class="offcanvas offcanvas-end" tabindex="-1" id="top-navbar" aria-labelledby="top-navbarLabel">
                        <button class="navbar-toggler border-0" type="button" data-bs-toggle="offcanvas" data-bs-target="#top-navbar" aria-controls="top-navbar">
                            <div class="d-flex justify-content-between p-3">
                                <Logo />
                                <span class="material-symbols-outlined">close</span>
                            </div>
                        </button>
                        <ul class="navbar-nav ms-lg-auto p-4 p-lg-0">
                            <li class="nav-item px-3 px-lg-0 py-1 py-lg-4">
                                <button type="button" class="nav-link">
                                    <span class="material-symbols-outlined">analytics</span>Relatórios
                                </button>
                            </li>
                            <li class="nav-item px-3 px-lg-0 py-1 py-lg-4">
                                <a class="nav-link" href="/admin/filiado">
                                    <span class="material-symbols-outlined">business</span>Afiliados
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
            <div class="col-12 col-lg-2 mobile-hide invisible"></div>            
        </section>
    )
}

export default MenuLateral;
